import { useEffect } from 'react';

export const useOutsideClick = (ref, callback, exception = null) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target) && (!exception || exception !== e.target.id)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};
